import { render, staticRenderFns } from "./ChannelProfile.vue?vue&type=template&id=18bb3bed&"
import script from "./ChannelProfile.vue?vue&type=script&lang=js&"
export * from "./ChannelProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports